import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nodes: [
    {
      id: "0",
      type: "input",
      data: {
        label: "Initiation",
        basic_details: {
          stage_name: "Initiation",
          email_notification: false,
          is_initial_stage: true,
        },
        dependency: [],
        primary_actions: [
          {
            stage_status_id: 1,
            stage_status_name: {
              label: "Initiate",
              value: 1,
            },
            roles_id: [],
            roles_name: [],
            employees_id: [],
            employees_name: [],
            action_criteria_id: null,
            action_criteria_name: {},
          },
        ],
        secondary_actions: [],
        sla: [],
      },
      position: { x: 0, y: 50 },
    },
  ],
  edges: [],
};

const workflowNode_slice = createSlice({
  name: "workflowNode",
  initialState,
  reducers: {
    replaceNodeById: (state, action) => {
      const { id, newNode } = action.payload;
      state.nodes = state.nodes.map((node) =>
        node.id === id ? { ...newNode, id } : node
      );
    },
    set_nodes: (state, action) => {
      state.nodes = action.payload;
    },
    set_edges: (state, action) => {
      state.edges = action.payload;
    },
    set_workflow_node: (state, action) => action.payload,
    reset_workflow_node: () => initialState,
  },
});

export default workflowNode_slice.reducer;

export const {
  replaceNodeById,
  set_nodes,
  set_edges,
  set_workflow_node,
  reset_workflow_node,
} = workflowNode_slice.actions;
